import superagent from 'superagent';

export default async function getEmbarques(webservice, getCookie, idioma) {
  let response = {};
  let kit = getCookie('usuarioOk');

  await superagent
    .get(
      `${webservice}/getEmbarques?usuarioOK=${kit}&dominio=${window.location.hostname}&idioma=${idioma}`,
    )
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
